import styled from 'styled-components'
// import {
//   default as VARIABLES
// } from '../../themes/styles/variables'

// Wrapper
// ============================================================
export const BuyerDetailFormStyle = styled.div`
  /* Parent styles
  ------------------------------- */
  width: 100%;

  /* Child element styles
  ------------------------------- */

  .main-content {
    min-height: calc(100vh - 267px);
  }

  .loading {
    justify-content: center;
    align-items: center;
  }

  /* Modifiers
  ------------------------------- */

  /* Media queries
  ------------------------------- */
`
